import { render, staticRenderFns } from "./StockTakingReports.vue?vue&type=template&id=18f1ea98&"
import script from "./StockTakingReports.vue?vue&type=script&lang=js&"
export * from "./StockTakingReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports